import type { BatchData } from '../types';
import { STATUS_COLORS } from '../lib/defaultBatch';
import type { BatchStats } from '../lib/stats';

interface Props {
  stats: BatchStats;
  status: BatchData['batchStatus'];
  onStatusChange: (s: BatchData['batchStatus']) => void;
}

export default function StatsRow({ stats, status, onStatusChange }: Props) {
  return (
    <div className="stats-row">
      <div className="stat-card">
        <div className="stat-label">Ingredients</div>
        <div className="stat-value">{stats.ingredientCount || '—'}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Batch weight</div>
        <div className="stat-value">
          {stats.totalWeight > 0 ? (
            <>
              {stats.totalWeight.toFixed(2)}
              <span className="stat-unit">g</span>
            </>
          ) : (
            '—'
          )}
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Phases</div>
        <div className="stat-value">{stats.phaseCount || '—'}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Status</div>
        <div className="status-wrap">
          <div
            className="status-dot"
            style={{ background: STATUS_COLORS[status] ?? '#aaa' }}
          />
          <select
            className="status-sel"
            value={status}
            onChange={(e) =>
              onStatusChange(e.target.value as BatchData['batchStatus'])
            }
          >
            <option value="draft">Draft</option>
            <option value="in-progress">In Progress</option>
            <option value="testing">Testing</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="archived">Archived</option>
          </select>
        </div>
      </div>
    </div>
  );
}
